import HomeworkLogin from '@/shared/publish/Homework/Login';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/Login')({
  component: RouteComponent,
})

function RouteComponent() {
  return <HomeworkLogin />
}
